module.exports = __webpack_public_path__ + "static/media/7.0c081d51.jpg";